module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-intro-zeroone"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content fb-bg-dark"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ccb662"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/SectionIntroZeroOne.vue
// module id = 1829
// module chunks = 1